import { Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NavigationItem } from '@base/navigation/navigation.types';
import { NavigationService } from 'app/core/navigation/navigation.service';

@Component({
  selector: 'app-navigation-items',
  templateUrl: './navigation-items.component.html',
  styleUrl: './navigation-items.component.scss',
  imports: [
    MatButtonModule,
    MatExpansionModule,
    MatIconModule,
    MatListModule,
    MatRippleModule,
    RouterLink,
    RouterLinkActive,
    MatToolbarModule,
    MatSidenavModule,
  ],
})
export class NavigationItemsComponent {
  private _navigationService = inject(NavigationService);
  readonly navigation = this._navigationService.navigation;

  // Track expanded state of collapsible items
  expandedItems = signal<Set<string>>(new Set());

  /**
   * Toggle expansion of collapsible navigation item
   */
  toggleCollapsible(itemId: string): void {
    const expanded = this.expandedItems();
    const newExpanded = new Set(expanded);

    if (newExpanded.has(itemId)) {
      newExpanded.delete(itemId);
    } else {
      newExpanded.add(itemId);
    }

    this.expandedItems.set(newExpanded);
  }

  /**
   * Check if item is expanded
   */
  isExpanded(itemId: string): boolean {
    return this.expandedItems().has(itemId);
  }

  /**
   * Track function for navigation items
   */
  trackByFn(index: number, item: NavigationItem): any {
    return item.id || index;
  }
}
